var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sidebar",class:{
    'sidebar-expanding': _vm.expanding,
    'sidebar-chinese': _vm.language === 'zh-CN',
    'sidebar-english': _vm.language !== 'zh-CN'
  }},[_c('el-menu',_vm._b({attrs:{"mode":"vertical","unique-opened":_vm.uniqueOpened,"default-active":_vm.$route.path,"collapseTransition":false},on:{"select":_vm.handleSelect}},'el-menu',_vm.$attrs,false),[_c('sidebar-item',{attrs:{"routes":_vm.routes}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }